import React from 'react';

import { colors, fonts, container } from '../theme';
import { heroCocktail } from '../data';

export default function Hero() {
  return (
    <section style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <div
        className="lyfe-hero-media"
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '46vw',
          maxWidth: 760,
          height: '100%',
          borderRadius: '9999px 0 0 9999px',
          overflow: 'hidden',
        }}>
        <img
          src={heroCocktail}
          alt="Cocktail at a Miami bar"
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.94 }}
        />
        <div
          className="lyfe-hero-scrim"
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(90deg,#0A0A0C 0%,rgba(10,10,12,.4) 24%,transparent 58%),linear-gradient(205deg,rgba(49,56,236,.34),transparent 60%)',
          }}
        />
      </div>

      <div className="lyfe-wrap" style={{ ...container, position: 'relative', zIndex: 2, padding: '0 40px' }}>
        <div style={{ maxWidth: 760 }}>
          <div
            style={{
              fontSize: 12,
              letterSpacing: '.26em',
              textTransform: 'uppercase',
              color: colors.muted2,
              fontWeight: 600,
              marginBottom: 28,
            }}>
            Miami · Tonight
          </div>
          <h1
            className="lyfe-hero-title"
            style={{
              fontFamily: fonts.serif,
              fontWeight: 300,
              fontSize: 'clamp(56px,7vw,104px)',
              lineHeight: 1.0,
              letterSpacing: '-.015em',
            }}>
            The night starts
            <br />
            right <span style={{ fontStyle: 'italic', color: colors.blue }}>here</span>, right{' '}
            <span style={{ fontStyle: 'italic', color: colors.orange }}>now</span>.
          </h1>
          <p
            className="lyfe-hero-copy"
            style={{
              fontSize: 'clamp(17px,1.4vw,20px)',
              lineHeight: 1.55,
              color: colors.muted,
              marginTop: 32,
              maxWidth: 440,
            }}>
            Lyfe shows you where to go next — live deals, real crowds, zero guesswork. Open the app and let the night
            unfold.
          </p>
          <div style={{ display: 'flex', gap: 14, marginTop: 40, flexWrap: 'wrap' }}>
            <a
              className="lyfe-btn"
              href="#get"
              style={{
                background: colors.orange,
                color: colors.ink,
                fontWeight: 600,
                fontSize: 15,
                padding: '16px 32px',
                borderRadius: 999,
                textDecoration: 'none',
              }}>
              Get the app
            </a>
            <a
              className="lyfe-btn lyfe-ghost"
              href="#tonight"
              style={{
                border: '1px solid rgba(255,255,255,.24)',
                color: colors.ink,
                fontSize: 15,
                padding: '16px 32px',
                borderRadius: 999,
                textDecoration: 'none',
              }}>
              Browse the deals
            </a>
          </div>
        </div>
      </div>

      <div
        style={{
          position: 'absolute',
          left: 40,
          bottom: 34,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          color: colors.muted4,
          fontSize: 13,
          letterSpacing: '.04em',
          zIndex: 2,
        }}>
        <span style={{ width: 34, height: 1, background: colors.muted4, display: 'inline-block' }} /> Scroll to explore
      </div>
    </section>
  );
}
